export default __webpack_public_path__ + "static/media/gallery_04.57620e7d.jpg";